import GreetingNode from './_GreetingNode';

export default GreetingNode;
